import AdministrationPage from '../components/AdministrationPage.vue';

export default [
    {
      path: "/Administration",
      name: "Administration",
      component: AdministrationPage,
      meta: {
        requiresAuth: true,
        checkPermissions: true,
        module: "administration",
        title: "CruzControl | Administration"
      }
    },
    {
      path: "/Administration/RabbitMQ",
      name: "RabbitMQ Dashboard",
      component: AdministrationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "administration", feature: "rabbitmq" }
    },
    {
      path: "/Administration/SiteConfig",
      name: "Site Configuration",
      component: AdministrationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "administration", feature: "site_config" }
    },
    {
      path: "/Administration/DeploymentInfo",
      name: "Deployment Info",
      component: AdministrationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "administration", feature: "deployment_info" }
    },
    {
      path: "/Administration/TenantOverview",
      name: "Tenant Overview",
      component: AdministrationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "administration", feature: "tenant_overview" }
    },
    {
      path: "/Administration/SystemMessages",
      name: "System Messages",
      component: AdministrationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "administration", feature: "system_messages" }
    },
    {
      path: "/Administration/AdminLogs",
      name: "Admin Logs",
      component: AdministrationPage,
      meta: { requiresAuth: true, checkPermissions: true, module: "administration", feature: "admin_logs" }
    },
]
